import React, { useMemo } from "react";
import { Card } from "antd";
import {
    InfoCircleOutlined,
    DatabaseOutlined,
    SettingOutlined,
    SecurityScanOutlined,
    AuditOutlined,
    MailOutlined
} from "@ant-design/icons";
import "./Public.css";

const PrivacyPublicPage = () => {
    const sections = useMemo(() => [
        {
            id: "commitment",
            title: "Our Commitment to Privacy",
            icon: <InfoCircleOutlined />,
            intro: "At IAmDojo, we are committed to protecting your privacy and the personal information you share with us. This Privacy Policy outlines how we collect, use, and safeguard your data when you interact with our platform or attend our physical dojo."
        },
        {
            id: "collection",
            title: "Information We Collect",
            icon: <DatabaseOutlined />,
            intro: "We collect specific sets of information to facilitate a smooth training experience and maintain secure records:",
            bullets: [
                "Personal information such as name, age, contact details, and emergency contact information.",
                "Attendance records, training progress, and performance logs.",
                "Payment and billing details, as necessary for enrollment and transactions."
            ]
        },
        {
            id: "usage",
            title: "How We Use Your Information",
            icon: <SettingOutlined />,
            intro: "Your personal and training data is processed for the following administrative and service-oriented activities:",
            bullets: [
                "To manage student enrollment and training schedules.",
                "To communicate important announcements and updates.",
                "To maintain safety and health records as required."
            ]
        }
    ], []);

    return (
        <div className="privacy-page-container">
            {/* Hero Header */}
            <header className="privacy-hero">
                <div className="privacy-hero-content">
                    <span className="privacy-badge">Effective Date: May 28, 2026</span>
                    <h1 className="privacy-title">IAmDojo Privacy Policy</h1>
                    <p className="privacy-subtitle">
                        IAmDojo Karate Institute Privacy Policy and Data Safeguarding Measures
                    </p>
                </div>
            </header>

            {/* Main Content Layout */}
            <main className="privacy-content-simple">
                <div className="policy-cards-stack">
                    {sections.map((section) => (
                        <Card key={section.id} className="policy-card" bordered={false}>
                            <div className="card-header-flex">
                                <div className="card-icon-wrapper">{section.icon}</div>
                                <h2 className="card-title-text">{section.title}</h2>
                            </div>

                            <div className="card-body-text">
                                <p>{section.intro}</p>

                                {section.bullets && (
                                    <ul>
                                        {section.bullets.map((bullet, index) => (
                                            <li key={index}>{bullet}</li>
                                        ))}
                                    </ul>
                                )}
                            </div>
                        </Card>
                    ))}
                </div>
            </main>

            {/* Footer */}
            <footer className="privacy-footer">
                <div>
                    © {new Date().getFullYear()} IAmDojo Karate Institute. All rights reserved. |{" "}
                    <a href="/login">Terms of Service</a>
                </div>
            </footer>
        </div>
    );
};

export default PrivacyPublicPage;
